import '@fortawesome/fontawesome-free/css/all.min.css'
import 'bootstrap-css-only/css/bootstrap.min.css'
import 'mdbvue/lib/css/mdb.min.css'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';
import './assets/custom.css';

// import socketio from 'socket.io';
import VueSocketIO from 'vue-socket.io';
import CKEditor from "@ckeditor/ckeditor5-vue2";


// export const SocketInstance = socketio('https://fastmind-services.herokuapp.com');

// Vue.use(VueSocketIO, SocketInstance)

Vue.use(new VueSocketIO({
    debug: true,
    connection: 'https://fastmind-services.herokuapp.com',
    options: {
        query: {
            token: localStorage.getItem("fastTeacherToken"),
        }
    }

}))

Vue.use(require('vue-moment'));

Vue.use(VueToast, {
    // One of the options
    position: 'top-right',
    dismissible: true,
    queue: false
})

Vue.use(VueGoogleMaps, {
    load: {
        libraries: 'places'
    }
})

Vue.use(CKEditor);
Vue.prototype.$apiURI = "https://read.fastmind.mx/backend/api/v1/";
// Vue.prototype.$apiURI = "http://127.0.0.1:3002/backend/api/v1";

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')